export default __webpack_public_path__ + "static/media/excellence.6b77262e.png";